<template>
  <div>
    <b-loading
      :is-full-page="true"
      :active.sync="isFetchingSavedInfo"
      :can-cancel="false"
    ></b-loading>
    <div class="level">
      <div class="level-left">
        <h4 class="title is-4">{{ createOrUpdate }}</h4>
      </div>
      <div class="level-right">
        <span v-if="createOrUpdate === 'Edit'">
          <button
            :class="buttonSave"
            @click="saveAndSend(false)"
            v-show="!isAdminButDifferentId"
          >
            Save
          </button>
          &nbsp;
          <button
            :class="buttonSaveAndSend"
            @click="saveAndSend(true)"
            v-show="!isAdminButDifferentId"
          >
            Save & send
          </button>
        </span>
        <span v-else>
          <button :class="buttonSave" @click="saveAndSend(false)">Save</button>
          &nbsp;
          <button :class="buttonSaveAndSend" @click="saveAndSend(true)">
            Save & send
          </button>
        </span>
        <span v-show="poRequest.poRequestId != 0"
          >&nbsp;
          <button :class="buttonDownloadPoRequest" @click="downloadPdf">
            Download pdf
          </button>
        </span>
        &nbsp;
        <span v-if="hasAdminPriv">
          <router-link
            :to="{
              name: 'List of PO Requests for Final Approval',
              params: { byStatus: 'all', pageSize: 10 }
            }"
            class="button is-small"
            >View list</router-link
          >
        </span>
        <span v-else>
          <router-link
            :to="{
              name: 'List of PO Requests',
              params: { byStatus: 'all', pageSize: 10 }
            }"
            class="button is-small"
            >View list</router-link
          >
        </span>
        &nbsp;
        <button class="button is-small" @click="goBack">Go back</button>
      </div>
    </div>
    <hr />
    <div class="columns">
      <div class="column is-2">
        <div class="field">
          <label class="label is-small"
            ><span class="level">
              <span class="level-left"> Client P.O. # </span>
              <span class="level-right">
                <span v-if="isCheckingIfPoNumberAvailable">
                  <span style="font-size: 9px">
                    <i>Checking availability...</i>
                  </span>
                </span>
              </span>
            </span></label
          >
          <div class="control">
            <input
              type="text"
              @keyup="checkIfPoNumberAlreadyExists"
              class="input is-small"
              v-model="poRequest.poNumber"
              v-validate="'required'"
              id="poNumber"
              name="P.O. number"
              placeholder="Enter Client P.O #"
            />
            <span style="font-size: 12px" class="has-text-danger">{{
              errors.first("P.O. number")
            }}</span>
            <p
              style="font-size: 12px"
              class="has-text-danger"
              v-if="poNumberVal"
              v-text="poNumberVal"
            ></p>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-1">
        <div class="field">
          <label class="label is-small">Request Type</label>
          <div class="select is-small">
            <select
              @change="requestTypeChange"
              v-model="poRequestDetailForTable.requestType"
              id="requestType"
            >
              <option value="0">Component</option>
              <option value="1">Commission</option>
              <option value="2">Services</option>
            </select>
          </div>
        </div>
      </div>
      <div class="column is-1">
        <div class="field">
          <label class="label is-small">UoM</label>
          <div class="select is-small">
            <select
              id="uOm"
              :disabled="disableForCommision"
              v-model="poRequestDetailForTable.unitOfMeasurement"
            >
              <option value="">None</option>
              <option value="0">box(es)</option>
              <option value="1">pc(s)</option>
              <option value="2">unit(s)</option>
              <option value="3">set(s)</option>
              <option value="4">ea</option>
              <option value="5">lic</option>
              <option value="6">lot</option>
            </select>
          </div>
        </div>
      </div>
      <div class="column is-1">
        <div class="field">
          <label class="label is-small">Quantity</label>
          <div class="control">
            <input
              id="quantity"
              :disabled="disableForCommision"
              type="number"
              class="input is-small"
              @keyup="quantityOrUnitCostKeyUp"
              v-model="poRequestDetailForTable.quantity"
            />
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Product Name/Name</label>
          <div class="control">
            <input
              id="productName"
              type="text"
              class="input is-small"
              v-model="poRequestDetailForTable.name"
            />
          </div>
        </div>
      </div>
      <div class="column is-1">
        <div class="field">
          <label class="label is-small">Description</label>
          <div class="control">
            <textarea
              id="desc"
              type="text"
              class="input is-small"
              v-model="poRequestDetailForTable.desc"
            />
          </div>
        </div>
      </div>
      <div class="column is-1">
        <div class="field">
          <label class="label is-small">Unit Cost</label>
          <div class="control">
            <input
              id="unitCost"
              :disabled="disableForCommision"
              type="number"
              class="input is-small"
              @keyup="quantityOrUnitCostKeyUp"
              v-model="poRequestDetailForTable.unitCost"
            />
          </div>
        </div>
      </div>
      <div class="column is-1">
        <div class="field">
          <label class="label is-small">Initial Cost</label>
          <div class="control">
            <input
              type="number"
              class="input is-small"
              v-model="poRequestDetailForTable.initialCost"
            />
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Supplier</label>
          <div class="control">
            <b-autocomplete
              id="searchSupplier"
              v-model="supplierName"
              size="is-small"
              :data="suppliers"
              placeholder="Search suppliers"
              @select="option => (selectedSupplier = option)"
              @input="searchSuppliers"
              :disabled="disableForCommision"
              :loading="isFetchingSuppliers"
            >
              <template slot="empty">
                <span v-if="isFetchingSuppliers"> Please wait... </span>
                <span v-if="suppliers.length === 0"> No results found </span>
              </template>
            </b-autocomplete>
          </div>
        </div>
      </div>
      <div class="column is-1">
        <div class="field">
          <label class="label is-small">Order basis</label>
          <div class="control">
            <b-checkbox
              v-model="poRequestDetailForTable.isOrderBasis"
              type="is-info"
              size="is-small"
            >
              Yes
            </b-checkbox>
            <!-- <b-checkbox
              v-model="poRequestDetailForTable.isIncludeInSi"
              type="is-info"
              size="is-small"
            >
              S.I
            </b-checkbox>
            <b-checkbox
              v-model="poRequestDetailForTable.isIncludeInDr"
              type="is-info"
              size="is-small"
            >
              D.R
            </b-checkbox> -->
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">&nbsp;</label>
          <div class="control">
            <button
              id="addSubDetail"
              class="button is-small is-info"
              @click="addOrEditToPoRequestDetail"
            >
              {{ addOrEditToTable }}
            </button>
            &nbsp;
            <button
              class="button is-small"
              v-if="addOrEditToTable === 'Update'"
              @click="cancelSelectedPoRequestDetail"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>

    <b-table :data="poRequest.poRequestDetails" :loading="isLoadingTable">
      <template slot-scope="item">
        <b-table-column
          class="table-column-content-is-small"
          label="Request Type"
        >
          <span v-if="item.row.requestType === 0">Component</span>
          <span v-if="item.row.requestType === 1">Commission</span>
          <span v-if="item.row.requestType === 2">Services</span>
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="UoM">
          <span
            v-if="
              item.row.unitOfMeasurement === null ||
                item.row.unitOfMeasurement === ''
            "
            >-</span
          >
          <span v-else>
            <p v-show="item.row.unitOfMeasurement == 0">box(es)</p>
            <p v-show="item.row.unitOfMeasurement == 1">pc(s)</p>
            <p v-show="item.row.unitOfMeasurement == 2">unit(s)</p>
            <p v-show="item.row.unitOfMeasurement == 3">set(s)</p>
            <p v-show="item.row.unitOfMeasurement == 4">ea</p>
            <p v-show="item.row.unitOfMeasurement == 5">lic</p>
            <p v-show="item.row.unitOfMeasurement == 6">lot</p>
          </span>
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="Quantity">
          {{ item.row.quantity }}
        </b-table-column>
        <b-table-column
          class="table-column-content-is-small"
          label="Product Name/Name"
        >
          {{ item.row.productName }}
        </b-table-column>
        <b-table-column
          class="table-column-content-is-small"
          label="Description"
        >
          {{ item.row.desc }}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="Unit Cost">
          {{ item.row.unitCost | formatNumber }}
        </b-table-column>
        <b-table-column
          class="table-column-content-is-small"
          label="Initial Cost"
        >
          {{ item.row.initialCost | formatNumber }}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="Supplier">
          {{ item.row.supplier }}
        </b-table-column>
        <b-table-column
          class="table-column-content-is-small"
          label="Order Basis"
        >
          <span v-if="item.row.isOrderBasis">Yes</span>
          <span v-else>No</span>
          <!-- S.I: <span v-if="item.row.isIncludeInSi">Yes</span>
          <span v-else>No</span>
          | D.R:
          <span v-if="item.row.isIncludeInDr">Yes</span><span v-else>No</span> -->
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label=" ">
          <button
            class="button is-warning is-small"
            @click="selectForEdit(item.row)"
          >
            Edit
          </button>
          &nbsp;
          <button
            :class="buttonDelete"
            @click="
              removeFromTable(
                item.row.poRequestDetailId
                  ? item.row.poRequestDetailId
                  : item.row.tempId
              )
            "
          >
            Delete
          </button>
        </b-table-column>
      </template>
    </b-table>
    <div style="clear: both" />
    <hr />
    <div class="columns">
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Total selling</label>
          <div class="control">
            <input
              type="number"
              id="totalSelling"
              class="input is-small"
              v-model="selling"
              @keyup="sellingKeyUp"
              v-validate="'required|decimal:2'"
              name="Total selling"
            />
            <span style="font-size: 12px" class="has-text-danger">{{
              errors.first("Total selling")
            }}</span>
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">P.O. request date</label>
          <div class="control">
            <input
              id="poRequestDate"
              type="date"
              class="input is-small"
              v-model="poRequest.poRequestDate"
            />
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Transaction Type</label>
          <div class="select is-small">
            <select v-model="poRequest.transactionType" id="transactionType">
              <option value="0">SALES INVOICE</option>
              <option value="1">DELIVERY RECEIPT ONLY</option>
              <option value="2">ZERO RATED/NON-VAT</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Agent name</label>
          <div class="control">
            <input
              type="text"
              class="input is-small"
              v-model="agentName"
              readonly
            />
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Clients</label>
          <div class="control">
            <b-autocomplete
              id="client"
              v-model="clientName"
              size="is-small"
              :data="clients"
              placeholder="Search clients"
              @select="option => (selectedClient = option)"
              @input="searchClients"
              v-validate="'required'"
              name="Client"
              :loading="isFetchingClients"
            >
              <template slot="empty">
                <span v-if="isFetchingClients"> Please wait... </span>
                <span v-if="clients.length === 0"> No results found </span>
              </template>
            </b-autocomplete>
            <span style="font-size: 12px" class="has-text-danger">{{
              errors.first("Client")
            }}</span>
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Terms</label>
          <div class="control">
            <input
              type="text"
              class="input is-small"
              v-model="clientTerm"
              disabled
            />
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Comments</label>
          <div class="control">
            <textarea
              type="text"
              class="input is-small"
              v-model="poRequest.comments"
            />
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Status</label>
          <div class="select is-small">
            <select v-model="poRequest.status">
              <option value="0">Low Priority</option>
              <option value="1">Medium Priority</option>
              <option value="2">High Priority</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-8"></div>
      <div class="column is-2" v-show="poRequest.poRequestId !== 0">
        <div class="field">
          <label class="label is-small">Approve</label>
          <div class="control">
            <span v-if="!hasAdminSalesAndMainAdminPriv">
              <span v-if="poRequest.isApprove"
                ><strong>Yes</strong>&nbsp;<span
                  v-if="poRequest.approvedByName"
                  style="font-size: 11px"
                  >(by {{ poRequest.approvedByName }})</span
                ></span
              >
              <span v-else><strong>No</strong></span>
            </span>
            <span v-else>
              <b-switch size="is-small" v-model="poRequest.isApprove" />
            </span>
          </div>
        </div>
      </div>
      <div class="column is-2" v-show="poRequest.poRequestId !== 0">
        <div class="field">
          <label class="label is-small">Final Approver</label>
          <div class="control">
            <span v-if="!hasAdminSalesAndMainAdminPriv">
              <span v-if="poRequest.isApproveByFinalApprover"
                ><strong>Yes</strong>&nbsp;<span
                  v-if="poRequest.finalApproverName"
                  style="font-size: 11px"
                  >(by {{ poRequest.finalApproverName }})</span
                ></span
              >
              <span v-else><strong>No</strong></span>
            </span>
            <span v-else>
              <b-switch
                size="is-small"
                v-model="poRequest.isApproveByFinalApprover"
                :disabled="!hasAdminPriv"
                @input="finalApprovalSwitchChanged"
              />
            </span>
          </div>
        </div>
      </div>
    </div>
    <h5 class="title is-5">Total</h5>
    <div class="notification">
      <loading
        :active.sync="isLoadingTotal"
        color="#3BAFDA"
        :can-cancel="false"
        :is-full-page="isFullPage"
      ></loading>
      <div class="level">
        <div class="level-left">
          <div class="columns">
            <div class="column is-12">
              <div class="field">
                <label class="label is-small">Total cost</label>
                <div class="control">
                  {{ poRequest.totalCost | formatNumber }}
                </div>
              </div>
            </div>
            <div class="column is-12">
              <div class="field">
                <label class="label is-small">Margin</label>
                <div class="control">{{ poRequest.margin }}%</div>
              </div>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="field">
            <label class="label is-small">Profit</label>
            <div class="control">
              <h4 class="title is-4">
                {{ this.poRequest.profit | formatNumber }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="level"
      v-if="
        (poRequest.isApproveByFinalApprover &&
          this.poRequest.isRequestForEdit &&
          this.hasAdminPriv) ||
          (poRequest.isApproveByFinalApprover && this.hasAdminSalesPriv)
      "
    >
      <div class="level-left"></div>
      <div class="level-right">
        <div class="columns">
          <div class="column is-4">
            <div class="field">
              <label class="label is-small">&nbsp;</label>
              <div class="control">
                <b-checkbox
                  v-model="poRequest.isRequestForEdit"
                  type="is-info"
                  size="is-small"
                  :disabled="!hasAdminSalesPriv"
                >
                  <strong>Request for Edit</strong>
                </b-checkbox>
              </div>
            </div>
          </div>
          <div class="column is-8">
            <div class="field">
              <label class="label is-small">Reason</label>
              <div class="control">
                <textarea
                  type="text"
                  style="margin: 0px; height: 64px; width: 260px"
                  class="input is-small"
                  :disabled="!poRequest.isRequestForEdit || !hasAdminSalesPriv"
                  v-model="poRequest.requestEditMessage"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="level">
      <div class="level-left"></div>
      <div class="level-right">
        <span v-if="createOrUpdate === 'Edit'">
          <button
            class="button is-small"
            v-if="poRequest.history"
            @click="showHistoryLog"
          >
            <i class="fas fa-history"></i>&nbsp;History
          </button>
          &nbsp;
          <button :class="buttonSave" @click="saveAndSend(false)">
            Save
            <span v-show="isAdminButDifferentId"
              >&nbsp;and notify agent about the status</span
            >
          </button>
          <!-- &nbsp;
          <button
            :class="buttonSaveAndSend"
            @click="saveAndSend(true)"
            v-show="!isAdminButDifferentId"
            id=""
          >
            Save & send
          </button> -->
        </span>
        <span v-else>
          <button :class="buttonSave" @click="saveAndSend(false)">Save</button>
          &nbsp;
          <button
            id="createData"
            :class="buttonSaveAndSend"
            @click="saveAndSend(true)"
          >
            Save & send
          </button>
        </span>
        <span v-show="poRequest.poRequestId != 0">
          &nbsp;
          <button :class="buttonDownloadPoRequest" @click="downloadPdf">
            Download pdf
          </button>
        </span>
        &nbsp;
        <span v-if="hasAdminPriv">
          <router-link
            :to="{
              name: 'List of PO Requests for Final Approval',
              params: { byStatus: 'all', pageSize: 10 }
            }"
            class="button is-small"
            >View list</router-link
          >
        </span>
        <span v-else>
          <router-link
            :to="{
              name: 'List of PO Requests',
              params: { byStatus: 'all', pageSize: 10 }
            }"
            class="button is-small"
            >View list</router-link
          >
        </span>
        &nbsp;
        <button class="button is-small" @click="goBack">Go back</button>
      </div>
    </div>
    <AttachFile
      :documentFiles="documentFiles"
      :documentInputRef="documentInputRef"
      @documentFilesFromAttachFile="documentFilesFromAttachFile"
    />
    <HistoryLog />
  </div>
</template>

<script>
import Vue from "vue";
import _ from "lodash";
import axios from "axios";
import AppToast from "../frontend/appToast";
import AppButton from "../frontend/appButton";
import Loading from "vue-loading-overlay";
import VueJWT from "vuejs-jwt";
import AuthService from "../../_services/auth";
import moment from "moment";
import AttachFile from "./AttachFile";
import HistoryLog from "./HistoryLog";
import { mapState, mapActions } from "vuex";
import numeral from "numeral";

Vue.use(VueJWT);
Vue.filter("formatNumber", function(value) {
  return numeral(value).format("0,0.00"); // displaying other groupings/separators is possible, look at the docs
});

const appToast = new AppToast();
const appButton = new AppButton();
const authService = new AuthService();

export default {
  components: {
    Loading,
    AttachFile,
    HistoryLog
  },
  data: () => ({
    documentFiles: new FormData(),
    documentInputRef: "documentInput",
    // user
    hasAdminSalesPriv: authService.hasAdminSalesPriv(),
    hasAdminSalesAndMainAdminPriv: authService.hasAdminSalesAndMainAdminPriv(),
    hasAdminPriv: authService.hasAdminPriv(),
    agentName: "",
    agentId: 0,
    isAdminButDifferentId: false,
    createOrUpdate: "Create",
    addOrEditToTable: "Add",
    isFetchingSavedInfo: false,
    buttonDelete: appButton.isLoadingDanger(false),
    buttonSave: appButton.isLoadingSuccess(false),
    buttonSaveAndSend: appButton.isLoadingSuccess(false),
    buttonDownloadPoRequest: appButton.isLoadingDefault(false),
    buttonToSendAndUpdateApprovalStatus: appButton.isLoadingSuccess(false),
    isLoadingTable: false,
    disableForCommision: false,
    clientTerm: "",
    poRequestDetailForTable: {
      requestType: 0,
      quantity: 0,
      unitCost: 0,
      initialCost: 0,
      unitOfMeasurement: ""
    },
    poRequest: {
      poRequestId: 0,
      status: 0,
      totalCost: 0,
      margin: 0,
      profit: 0,
      transactionType: 0,
      poRequestDetails: []
    },
    // search supplier
    supplierName: "",
    suppliers: [],
    selectedSupplier: 0,
    selectedSupplierForEdit: {},
    isFetchingSuppliers: false,
    // search clients
    clientName: "",
    clients: [],
    selectedClient: 0,
    isFetchingClients: false,
    // totals
    isLoadingTotal: false,
    isFullPage: false,
    selling: 0,
    // is po number exists
    poNumberVal: "",
    isCheckingIfPoNumberAvailable: false,
    isApproveFromRequest: false
  }),
  created() {
    const poRequestId = this.$route.params.poRequestId;

    var decodedToken = Vue.$jwt.decode(localStorage.getItem("token"));
    this.agentId = decodedToken.nameid;
    if (poRequestId) {
      this.getPoRequestById(poRequestId, this.agentId);
    } else {
      // CREATE Mode
      this.getCurrentDateFromServer();
      this.agentName = decodedToken.unique_name;
    }
  },
  methods: {
    ...mapActions("porequest", ["openHistoryLogModal"]),
    ...mapActions("misc", ["getTotalPoRequestForFinalApproval"]),
    goBack() {
      this.$router.go(-1);
    },
    getCurrentDateFromServer() {
      this.isFetchingSavedInfo = true;
      axios
        .get(`api/settings/current-date`)
        .then(response => {
          this.poRequest.poRequestDate = moment(response.data).format(
            "YYYY-MM-DD"
          );
        })
        .catch(error => console.log(error))
        .then(() => {
          this.isFetchingSavedInfo = false;
        });
    },
    showHistoryLog() {
      this.openHistoryLogModal({
        showHistoryLog: true,
        historyLog: this.poRequest.history
      });
    },
    isCurrentUserInSalesAdminApprover(salesAdminApprovers) {
      if (salesAdminApprovers) {
        const approvers = salesAdminApprovers.split(",");
        return approvers.filter(x => x === this.agentId) > 0
      }
    },
    finalApprovalSwitchChanged() {
      if (this.hasAdminPriv) {
        if (!this.isApproveFromRequest) {
          this.poRequest.isApprove = this.poRequest.isApproveByFinalApprover;
        }
      }
    },
    default() {
      this.$nextTick(() => {
        this.$validator.reset();
      });

      this.createOrUpdate = "Create";
      this.addOrEditToTable = "Add";
      this.isFetchingSavedInfo = false;
      this.buttonDelete = appButton.isLoadingDanger(false);
      this.buttonSave = appButton.isLoadingSuccess(false);
      this.buttonSaveAndSend = appButton.isLoadingSuccess(false);
      this.buttonDownloadPoRequest = appButton.isLoadingDefault(false);
      this.isLoadingTable = false;
      this.disableForCommision = false;

      this.clientTerm = "";
      this.poRequestDetailForTable = {
        requestType: 0,
        quantity: 0,
        unitCost: 0,
        initialCost: 0
      };
      this.poRequest = {
        poRequestId: 0,
        status: 0,
        totalCost: 0,
        margin: 0,
        profit: 0,
        poRequestDetails: []
      };
      // search supplier
      this.supplierName = "";
      this.suppliers = [];
      this.selectedSupplier = 0;
      this.selectedSupplierForEdit = {};
      this.isFetchingSuppliers = false;
      // search clients
      this.clientName = "";
      this.clients = [];
      this.selectedClient = 0;
      this.isFetchingClients = false;
      // totals
      this.isLoadingTotal = false;
      this.selling = 0;
    },
    downloadPdf() {
      const poRequestId = this.$route.params.poRequestId;
      if (poRequestId) {
        this.buttonDownloadPoRequest = appButton.isLoadingDefault(true);
        axios
          .get(`downloadables/porequest?id=${poRequestId}`, {
            responseType: "blob"
          })
          .then(response => {
            console.log(response.data);
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
              "download",
              `P.O. request by - ${this.agentName} - ${poRequestId}.pdf`
            );
            document.body.appendChild(link);
            link.click();
          })
          .catch(error => {
            console.log(error);
          })
          .then(
            () =>
              (this.buttonDownloadPoRequest = appButton.isLoadingDefault(false))
          );
      }
    },
    sendPoRequest(poRequestId) {
      if (poRequestId) {
        this.buttonSaveAndSend = appButton.isLoadingSuccess(true);
        axios
          .post(`downloadables/porequest?id=${poRequestId}&isSendToEmail=true`)
          .then(response => {
            appToast.success(response.data);
          })
          .catch(error => console.log(error))
          .then(
            () => (this.buttonSaveAndSend = appButton.isLoadingSuccess(false))
          );
      }
    },
    checkIfPoNumberAlreadyExists() {
      if (this.poRequest.poNumber) {
        this.isCheckingIfPoNumberAvailable = true;
        if (this.poRequest.poRequestId == 0) {
          axios
            .get(
              `api/porequests/check-if-po-number-exists/${
                this.poRequest.poNumber
              }`
            )
            .then(response => {
              this.poNumberVal = null;
            })
            .catch(error => {
              console.log(error);
              if (error.response) {
                this.poNumberVal = error.response.data;
              }
            })
            .then(() => {
              this.isCheckingIfPoNumberAvailable = false;
            });
        } else {
          axios
            .get(
              `api/porequests/check-if-po-number-exists-by-other-record/${
                this.poRequest.poNumber
              }/${this.poRequest.poRequestId}`
            )
            .then(response => {
              this.poNumberVal = null;
            })
            .catch(error => {
              console.log(error);
              if (error.response) {
                this.poNumberVal = error.response.data;
              }
            })
            .then(() => {
              this.isCheckingIfPoNumberAvailable = false;
            });
        }
      } else {
        this.poNumberVal = null;
        this.isCheckingIfPoNumberAvailable = false;
      }
    },
    updateApprovalStatus() {
      axios
        .put(
          `api/porequests/update-approval-status/${
            this.poRequest.poRequestId
          }/${this.poRequest.isApprove}`
        )
        .then(response => {
          appToast.success(response.data);
        })
        .catch(error => appToast.danger(error.message));
    },
    saveAndSend(isSend) {
      if (
        this.hasAdminPriv &&
        this.poRequest.isApproveByFinalApprover &&
        this.poRequest.isRequestForEdit
      ) {
        const isAccept = window.confirm(
          "Are you sure do you want to continue approving this request and clear the request for edit?"
        );
        if (!isAccept) {
          // do nothing
          return false;
        }
        // continue on update
      }

      if (
        this.hasAdminSalesAndMainAdminPriv &&
        this.poRequest.isRequestForEdit &&
        !this.poRequest.requestEditMessage
      ) {
        appToast.danger("Reason for edit request is required.");
        return false;
      }

      if (this.poRequest.poRequestDetails.length == 0) {
        appToast.danger("P.O. request detail is empty.");
        return false;
      }

      if (!this.poRequest.poRequestDate) {
        appToast.danger("P.O. request date is empty.");
        return false;
      }

      if (this.poRequest.profit < 0) {
        appToast.danger("Profit must be greater than or equal to 0.");
        return false;
      }

      this.$validator.validateAll().then(result => {
        if (result) {
          if (!isSend) {
            this.buttonSave = appButton.isLoadingSuccess(true);
          }
          const poRequestId = this.$route.params.poRequestId;
          this.poRequest.selling = this.selling;
          if (this.poRequest.poRequestId == 0) {
            // CREATE
            axios
              .post(`api/porequests/`, this.poRequest)
              .then(response => {
                appToast.success(response.data.message);
                if (isSend) {
                  this.sendPoRequest(response.data.id);
                }
                // this.saveAttachedFiles(response.data.id);
                this.$router.push({ name: "List of PO Requests" });
              })
              .catch(error => console.log(error))
              .then(() => {
                this.buttonSave = appButton.isLoadingSuccess(false);
              });
          } else {
            // EDIT
            if (poRequestId) {
              axios
                .delete(
                  `api/porequests/delete-detail-by-porequest-id/${poRequestId}`
                )
                .then(response => {
                  axios
                    .post(
                      `api/porequests/create-po-request-detail/${poRequestId}`,
                      this.poRequest.poRequestDetails
                    )
                    .then(response => {
                      axios
                        .put(`api/porequests/${poRequestId}`, this.poRequest)
                        .then(response => {
                          appToast.success(response.data);
                          if (this.isAdminButDifferentId) {
                            if (!this.poRequest.isApproveByFinalApprover) {
                              this.updateApprovalStatus();
                            }
                          }
                          if (isSend) {
                            // is send
                            this.sendPoRequest(poRequestId);
                          }
                        })
                        .catch(error => {
                          if (error.response) {
                            appToast.danger(error.response.data);
                          }
                          console.log(error);
                        })
                        .then(() => {
                          this.buttonSave = appButton.isLoadingSuccess(false);
                          this.getPoRequestById(poRequestId, this.agentId);
                        });
                    });
                })
                .catch(error => {
                  console.log(error);
                  if (error.response) {
                    appToast.danger(error.response.data);
                  }
                })
                .then(() => {
                  this.buttonSave = appButton.isLoadingSuccess(false);
                });
            }
          }
        }
      });
    },
    documentFilesFromAttachFile(data) {
      this.documentFiles = data.documentFiles;
    },
    saveAttachedFiles(poRequestId) {
      axios
        .post(`api/porequestfiles/upload/${poRequestId}`, this.documentFiles)
        .then(response => {
          appToast.success(response.data);
        })
        .catch(error => {
          if (error.response) {
            appToast.danger(error.response.data);
          }
        })
        .then(() => {
          //
        });
    },
    getPoRequestById(id, agentId) {
      this.isFetchingSavedInfo = true;
      this.createOrUpdate = "Edit";
      axios
        .get(`api/porequests/${id}`)
        .then(response => {
          this.poRequest = response.data;
          this.poRequest.poRequestDate = moment(
            this.poRequest.poRequestDate
          ).format("YYYY-MM-DD");
          this.clientName = this.poRequest.client;
          this.selling = this.poRequest.selling;
          this.agentName = this.poRequest.user;
          if (this.hasAdminSalesPriv) {
            if (this.poRequest.id != agentId) {
              this.isAdminButDifferentId = true;
            } else {
              this.isAdminButDifferentId = false;
            }
          }
          this.isApproveFromRequest = this.poRequest.isApprove;

          this.poRequest.isApprove = this.isCurrentUserInSalesAdminApprover(response.data.salesAdminApprovers)

          // get term by client id
          axios
            .get(`api/clients/get-term/${this.poRequest.clientId}`)
            .then(response => {
              this.clientTerm = response.data;
            })
            .catch(error => console.log("error fetching client term"));
        })
        .catch(error => console.log(error))
        .then(() => {
          this.isFetchingSavedInfo = false;
          this.getTotalPoRequestForFinalApproval();
        });
    },
    searchClients() {
      // authService.isLoggedIn() // check login
      axios
        .get(`api/searchqueries/clients-by-name/${this.clientName}/false`)
        .then(response => {
          this.clients = response.data;
        })
        .catch(error => console.log(error.response));
    },
    searchSuppliers() {
      // authService.isLoggedIn() // check login
      axios
        .get(`api/searchqueries/suppliers-by-name/${this.supplierName}`)
        .then(response => {
          this.suppliers = response.data;
        })
        .catch(error => console.log(error));
    },
    cancelSelectedPoRequestDetail() {
      this.defaultPoRequestForTable();
    },
    sellingKeyUp() {
      this.calculateTotalPo();
    },
    calculateTotalPo() {
      this.isLoadingTotal = true;
      const toCalculateTotalPo = {
        poRequestDetails: this.poRequest.poRequestDetails,
        selling: !this.selling ? 0 : this.selling
      };
      axios
        .post(`api/porequests/calculate-total-po`, toCalculateTotalPo)
        .then(response => {
          this.poRequest.totalCost = response.data.totalCost;
          this.poRequest.margin = response.data.margin;
          this.poRequest.profit = response.data.profit;
        })
        .catch(error => {
          if (error.response) {
            console.log(error.response.data);
            appToast.danger(error.response.data);
          }
        })
        .then(() => {
          setTimeout(() => {
            this.isLoadingTotal = false;
          }, 500);
        });
    },
    defaultPoRequestForTable() {
      this.poRequestDetailForTable = {
        requestType: 0,
        quantity: 0,
        unitCost: 0,
        initialCost: 0,
        unitOfMeasurement: "",
        id: `t${new Date().getTime()}`
      };

      this.addOrEditToTable = "Add";
      this.disableForCommision = false;

      this.supplierName = "";
      this.suppliers = [];
      this.selectedSupplier = 0;
      this.isFetchingSuppliers = false;
    },
    addOrEditToPoRequestDetail() {
      if (!this.poRequestDetailForTable.name) {
        appToast.danger("Product Name/Name is empty.");
        return false;
      }

      this.isLoadingTable = true;

      const requestTypeValue = parseInt(
        this.poRequestDetailForTable.requestType,
        10
      );

      // Update
      if (this.addOrEditToTable === "Update") {
        let index = null;
        let isUsingTempId = false;
        const idTypeOf = typeof this.poRequestDetailForTable.id; // check if it temp id
        if (idTypeOf === "string") {
          index = _.findIndex(this.poRequest.poRequestDetails, {
            tempId: this.poRequestDetailForTable.id
          });

          isUsingTempId = true;
        } else {
          index = _.findIndex(this.poRequest.poRequestDetails, {
            poRequestDetailId: this.poRequestDetailForTable.id
          });
        }

        let selectedSupplierIsNotEqual = false;
        if (this.selectedSupplier) {
          if (this.selectedSupplierForEdit.id != this.selectedSupplier.id) {
            selectedSupplierIsNotEqual = true;
          }
        }

        let supplierName = null;
        let supplierId = null;
        if (requestTypeValue !== 1) {
          supplierName = selectedSupplierIsNotEqual
            ? this.selectedSupplier.value
            : this.selectedSupplierForEdit.value;

          supplierId = selectedSupplierIsNotEqual
            ? this.selectedSupplier.id
            : this.selectedSupplierForEdit.id;
        }

        if (isUsingTempId) {
          // if using tempid, supply the tempId property if not, supply the primary key
          this.poRequest.poRequestDetails.splice(index, 1, {
            requestType: requestTypeValue,
            quantity:
              requestTypeValue === 1
                ? null
                : this.poRequestDetailForTable.quantity,
            productName: this.poRequestDetailForTable.name,
            desc: this.poRequestDetailForTable.desc,
            unitCost:
              requestTypeValue === 1
                ? null
                : this.poRequestDetailForTable.unitCost,
            initialCost: this.poRequestDetailForTable.initialCost,
            supplier: supplierName,
            supplierId: supplierId,
            isOrderBasis: this.poRequestDetailForTable.isOrderBasis,
            isIncludeInSi: this.poRequestDetailForTable.isIncludeInSi,
            isIncludeInDr: this.poRequestDetailForTable.isIncludeInDr,
            unitOfMeasurement: this.poRequestDetailForTable.unitOfMeasurement,
            tempId: this.poRequestDetailForTable.id
          });
        } else {
          this.poRequest.poRequestDetails.splice(index, 1, {
            requestType: requestTypeValue,
            quantity:
              requestTypeValue === 1
                ? null
                : this.poRequestDetailForTable.quantity,
            productName: this.poRequestDetailForTable.name,
            desc: this.poRequestDetailForTable.desc,
            unitCost:
              requestTypeValue === 1
                ? null
                : this.poRequestDetailForTable.unitCost,
            initialCost: this.poRequestDetailForTable.initialCost,
            supplier: supplierName,
            supplierId: supplierId,
            isOrderBasis: this.poRequestDetailForTable.isOrderBasis,
            isIncludeInSi: this.poRequestDetailForTable.isIncludeInSi,
            isIncludeInDr: this.poRequestDetailForTable.isIncludeInDr,
            unitOfMeasurement: this.poRequestDetailForTable.unitOfMeasurement,
            poRequestDetailId: this.poRequestDetailForTable.id
          });
        }
      } else {
        // Create
        this.poRequest.poRequestDetails = [
          ...this.poRequest.poRequestDetails,
          {
            requestType: requestTypeValue,
            quantity:
              requestTypeValue === 1
                ? null
                : this.poRequestDetailForTable.quantity,
            productName: this.poRequestDetailForTable.name,
            desc: this.poRequestDetailForTable.desc,
            unitCost:
              requestTypeValue === 1
                ? null
                : this.poRequestDetailForTable.unitCost,
            initialCost: this.poRequestDetailForTable.initialCost,
            supplier:
              requestTypeValue === 1 ? null : this.selectedSupplier.value,
            supplierId:
              requestTypeValue === 1 ? null : this.selectedSupplier.id, //poRequestDetailForTable.supplierId
            isOrderBasis: this.poRequestDetailForTable.isOrderBasis,
            isIncludeInSi: this.poRequestDetailForTable.isIncludeInSi,
            isIncludeInDr: this.poRequestDetailForTable.isIncludeInDr,
            unitOfMeasurement: this.poRequestDetailForTable.unitOfMeasurement,
            tempId: `t${new Date().getTime()}`
          }
        ];
      }
      this.isLoadingTable = false;
      this.calculateTotalPo();

      this.defaultPoRequestForTable();
    },
    selectForEdit(row) {
      this.addOrEditToTable = "Update";
      this.poRequestDetailForTable.requestType = row.requestType;
      this.poRequestDetailForTable.quantity = row.quantity;
      this.poRequestDetailForTable.name = row.productName;
      this.poRequestDetailForTable.desc = row.desc;
      this.poRequestDetailForTable.unitCost = row.unitCost;
      this.poRequestDetailForTable.initialCost = row.initialCost;
      this.poRequestDetailForTable.isOrderBasis = row.isOrderBasis;
      this.poRequestDetailForTable.isIncludeInSi = row.isIncludeInSi;
      this.poRequestDetailForTable.isIncludeInDr = row.isIncludeInDr;
      this.poRequestDetailForTable.unitOfMeasurement = row.unitOfMeasurement;

      // supplier
      this.supplierName = row.supplier;
      this.selectedSupplierForEdit.id = row.supplierId;
      this.selectedSupplierForEdit.value = row.supplier;

      // check if the id temporary or from saved item
      let tableId = 0;
      row.tempId ? (tableId = row.tempId) : (tableId = row.poRequestDetailId);

      this.poRequestDetailForTable.id = tableId;
      this.requestTypeChange();
    },
    removeFromTable(id) {
      this.isLoadingTable = true;
      this.buttonDelete = appButton.isLoadingDanger(true);
      // check if id is temp or with t
      const idTypeOf = typeof id;
      if (idTypeOf === "string") {
        // check if id is string, if it is string, remove from the array, if not, remove from the database
        const hasT = id.charAt(0);
        if (hasT === "t") {
          _.remove(this.poRequest.poRequestDetails, { tempId: id }); // Create module
        }
      } else {
        // delete if the id is from saved info
        _.remove(this.poRequest.poRequestDetails, { poRequestDetailId: id });
      }
      this.isLoadingTable = false;
      this.buttonDelete = appButton.isLoadingDanger(false);

      this.calculateTotalPo();
      this.defaultPoRequestForTable();
    },
    quantityOrUnitCostKeyUp() {
      this.poRequestDetailForTable.initialCost =
        this.poRequestDetailForTable.quantity *
        this.poRequestDetailForTable.unitCost;
    },
    requestTypeChange() {
      if (
        this.poRequestDetailForTable.requestType == 1 ||
        this.poRequestDetailForTable.requestType == 2
      ) {
        this.disableForCommision = true;
        this.poRequestDetailForTable.quantity = 0;
        this.poRequestDetailForTable.unitCost = 0;
        this.poRequestDetailForTable.unitOfMeasurement = "";

        this.supplierName = "";
        this.suppliers = [];
        this.selectedSupplier = 0;
        this.selectedSupplierForEdit = {};
        this.isFetchingSuppliers = false;
      } else {
        this.disableForCommision = false;
      }
    }
  },
  watch: {
    selectedClient() {
      if (this.selectedClient.id) {
        this.poRequest.clientId = this.selectedClient.id;
        this.clientTerm = this.selectedClient.description1;
      } else {
        this.selectedClient = 0;
        this.clientTerm = "";
      }
    },
    documentFiles() {
      console.log(this.documentFiles);
    }
  }
};
</script>
